import { render, staticRenderFns } from "./ModalAddPayment.vue?vue&type=template&id=c987e23a"
import script from "./ModalAddPayment.vue?vue&type=script&lang=js"
export * from "./ModalAddPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports